// extracted by mini-css-extract-plugin
module.exports = {"quickFilterRefinementRoot":"az_YKc"};